<app-push-aside-content [showAside]="showLeftNav" (overlayClose)="showLeftNav = false" asideWidth="280px" (click)="closeStatusMenu($event)">
  <app-aside-content>
    <app-left-nav></app-left-nav>
  </app-aside-content>
  <app-main-content>
    <app-header [actionLeft]="appHeaderLeftAction"></app-header>
    <app-banner-msg></app-banner-msg>
    <div class="dashboard-block-container">
        <div class="dashboard-flex-left"></div>
        <div class="dashboard-content strategies-dashboard-content">
        <div class="title-btn-flex-container">
          <div class="row">
            <div auto="my-plans-title" class="page-title">My Plans <span *ngIf="totalCount >= 0" class="plan-count">({{totalCount}} plans)</span></div>
            <div class="right-content">
              <cg-search
                #cgSearch
                (searchValueChanged)="searchValueChanged($event)"
                (searchCollapsed)="searchBarCollapsed()"
                (searchExpanded)="searchBarExpanded()"
                [expandedByDefault]="false"
                [loggingEnabled]="true"
                placeholderText="Search"
                [ngStyle]="{verticalAlign: 'top'}"
              ></cg-search>
              <button auto="new-strat-btn" class="btn new-strat-btn" *ngIf="canAddStrategy()" (click)="onCreateStrategy()">New Plan</button>
            </div>
          </div>

          <div class="row align-right" *ngIf="showHierarchyToggle">
            <div class="associated-institutions-container">
              <p class="instruction">Include Associated Institutions</p>
              <i class="eleot-icon icon-info"
                 tooltipStyleClass="attach-info-tooltip"
                 tooltipPosition="bottom"
                 pTooltip="Enabling this toggle will allow all content from institutions within your hierarchy to be shown."></i>
              <p-inputSwitch auto="include-associated-institutions-switch"
                             class="associated-institutions-switch-container"
                             styleClass="associated-institutions-switch"
                             onLabel=" "
                             offLabel=" "
                             [ngModel]="pageIncludeHierarchy"
                             (onChange)="onToggleAssociatedInstitutions($event)">
              </p-inputSwitch>
            </div>
          </div>

        </div>
        <!-- Total Records needs to be the number of available records on the server side -->
        <!-- Row height MUST be static for virtual scrolling to work -->
        <!-- Scroll height should be refined to make user experience more seemless -->
        <div class="dashboard-table-container">
          <p-table #strategiesDashboardTable
                   styleClass="dashboard-table strategies-dashboard-table"
                   selectionMode="single"
                   [value]="strategies"
                   (onRowSelect)="onStrategyRowDblClick($event)"
                   [multiSortMeta]="multiSortMeta"
                   [scrollable]="true"
                   scrollHeight="calc(100vh - 350px)"
                   [customSort]="true"
                   [loading]="(isLoading$ | async) === true"
                   [rows]="strategiesLength"
                   [totalRecords]="totalRecordCount > 1 ? totalRecordCount : 1"
                   [virtualRowHeight]="strategies.length > 0 ? 97 : 240"
                   [lazy]="true"
                   [virtualScroll]="true"
                   (onLazyLoad)="loadDataOnScroll($event)"
                   sortMode="multiple">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="strategyName">
                  Name
                  <p-sortIcon field="strategyName"></p-sortIcon>
                </th>
                <th pSortableColumn="institutionName">
                  Institution
                  <p-sortIcon field="institutionName"></p-sortIcon>
                </th>
                <th pSortableColumn="creatorFullName">
                  Creator
                  <p-sortIcon field="creatorFullName"></p-sortIcon>
                </th>
                <th class="last-modified-column" pSortableColumn="lastModifiedDate">
                  Last Modified
                  <p-sortIcon field="lastModifiedDate"></p-sortIcon>
                </th>
                <th class="start-date-column" pSortableColumn="startDate">
                  Start Date
                  <p-sortIcon field="startDate"></p-sortIcon>
                </th>
                <th class="end-date-column" pSortableColumn="endDate">
                  End Date
                  <p-sortIcon field="endDate"></p-sortIcon>

                </th>
                <th class="status-column">
                <shared-sort-filter-menu #statusMenu
                                         [toggleMenuButton]="toggleStatusMenuBtn"
                                         [menuOptions]="statusMenuOptions">
                  <button #toggleStatusMenuBtn
                          [attr.aria-label]="'Toggle status menu.'"
                          [attr.aria-expanded]="statusMenu.showMenu"
                          aria-haspopup="menu"
                          class="status-dropdown-btn"
                          [ngClass]="{'no-border-radius-bottom': statusMenu.showMenu}"
                          type="button"
                          (click)="toggleStatusMenu($event)">

                    <span class="my-header-text">Status
                    <i class="status-sort-icon eleot-icon"
                       [ngClass]="{'icon-arrow-down' : sortDirection === DESCENDINGZA, 'icon-arrow-up': sortDirection === ASCENDINGAZ}"
                       *ngIf="sortedColumn === 'statusFilterValue'"></i></span>
                        <span class="status-filter-count"
                              *ngIf="pageFilters.length > 0"
                              [attr.aria-label]="'Selected filters:' + pageFilters">({{pageFilters.length}})</span>
                        <i class="status-dropdown-icon eleot-icon icon-chevron-down"></i>
                      </button>
                  </shared-sort-filter-menu>
                </th>
                <th class="context-menu-column"><!-- placeholder column for context menu --></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-strategy>
              <tr [pSelectableRowDblClick]="strategy">
                <td>
                  <div class="dashboard-cell pointer">
                    <div class="v-center-content">
                      <div class="heavy-text clamp-4"
                           appSearchHighlight
                           [searchedWords]="searchWords$ | async"
                           [text]="strategy.strategyName"
                           classToApply="search-highlight"></div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="dashboard-cell pointer">
                    <div class="v-center-content">
                      <div class="main-text
                                  v-50-top"
                           appSearchHighlight
                           [searchedWords]="searchWords$ | async"
                           [text]="strategy.institutionName"
                           classToApply="search-highlight"></div>
                      <div class="subtext
                                  v-50-bottom"
                           appSearchHighlight
                           [searchedWords]="searchWords$ | async"
                           [text]="(strategy.institutionLocation ? strategy.institutionLocation.city + ', ' + strategy.institutionLocation.state : '')"
                           classToApply="search-highlight"></div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="dashboard-cell pointer">
                    <div class="v-center-content">
                      <div class="main-text
                                  v-50-top"
                           appSearchHighlight
                           [searchedWords]="searchWords$ | async"
                           [text]="strategy.creatorFullName"
                           classToApply="search-highlight"></div>
                      <div class="subtext v-50-bottom"
                           appSearchHighlight
                           [searchedWords]="searchWords$ | async"
                           [text]="strategy.creatorAssociatedInstitution"
                           classToApply="search-highlight"></div>
                    </div>
                  </div>
                </td>
                <td class="last-modified-column">
                  <div class="dashboard-cell pointer">
                    <div class="main-text solo"
                         appSearchHighlight
                         [searchedWords]="searchWords$ | async"
                         [text]="strategy.lastModifiedDate | date:'MM/dd/yyyy'"
                         classToApply="search-highlight"></div>
                  </div>
                </td>
                <td class="start-date-column">
                  <div class="dashboard-cell pointer">
                    <div class="main-text solo"
                         appSearchHighlight
                         [searchedWords]="searchWords$ | async"
                         [text]="strategy.startDate | date:'MM/dd/yyyy'"
                         classToApply="search-highlight"></div>
                  </div>
                </td>
                <td class="end-date-column">
                  <div class="dashboard-cell pointer">
                    <div class="main-text solo"
                         appSearchHighlight
                         [searchedWords]="searchWords$ | async"
                         [text]="strategy.endDate | date:'MM/dd/yyyy'"
                         classToApply="search-highlight"></div>
                  </div>
                </td>
                <td class="status-column">
                  <div class="dashboard-cell pointer">
                    <img class="progress-image" appProgressImg [progress]="strategy.status" [alt]="strategy.status">
                  </div>
                </td>
                <td class="context-menu-column">
                  <div class="dashboard-cell">
                    <i class="eleot-icon icon-options pointer" (click)="onToggleContextMenu($event, strategy)"></i>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr class="no-plans-msg-row">
                <td colspan="8" class="ui-table-empty-message" *ngIf="(isLoading$ | async) === false">
                  <ng-container *ngIf="!hasFiltersOrSearch()">
                    <img src="assets/images/strategies-icon-red.svg"/>
                    <h4>No Plans Found</h4>
                    <p>When you create new plans, they will be listed here.</p>
                  </ng-container>
                  <ng-container *ngIf="hasFiltersOrSearch()">
                    <img src="assets/images/filter-icon.svg"/>
                    <h4>No Results Found</h4>
                    <p>Please adjust your selections to see new results.</p>
                  </ng-container>
                </td>
                <td colspan="8" class="ui-table-empty-message" *ngIf="(isLoading$ | async) === true">
                  <div></div>
                </td>

              </tr>
            </ng-template>
          </p-table>
          <button class="dashboard-download-btn"
                  (click)="downloadSystemAggReport()"
                  pTooltip="Download Reports"
                  tooltipPosition="bottom">
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
      </div>
        <div class="dashboard-flex-right"></div>
    </div>
  </app-main-content>
</app-push-aside-content>

<p-menu #contextMenu styleClass="table-menu" [popup]="true" [model]="menuItems" appendTo="body"></p-menu>

<p-sidebar #strategySidebar
           [(visible)]="isStrategyDetailsVisible"
           appendTo="body"
           position="right"
           styleClass="strategies-sidebar"
           (onShow)="strategyDetails.onShowSidebar(strategySidebar)"
           (onHide)="strategyDetails.onHideSidebar()">
  <app-strategy-details #strategyDetails
                        (create)="onStrategyCreated($event)"
                        (createError)="onStrategyError($event)"
                        (edit)="onStrategyEdited($event)"
                        (editError)="onStrategyError($event)"
                        (cancel)="isStrategyDetailsVisible = false">
  </app-strategy-details>
</p-sidebar>

<p-dialog #downloadDialog styleClass="strategies-download-dialog no-animation-dialog" [showHeader]="false" [modal]="true" [closable]="false" [positionTop]="20">
    <app-strategy-map-download (close)="downloadDialog.visible = false"></app-strategy-map-download>
</p-dialog>

<p-dialog #confirmDialog styleClass="strategies-confirm-dialog" [modal]="true" [closable]="false">
  <p-header>
    <img src="assets/images/exclamation.svg" alt="Alert">
    <span class="dialog-title copy-dialog-title">Delete Plan</span>
  </p-header>
  <div>You are about to delete this plan and its contents:</div>
  <div>{{ selectedStrategy.strategyName }}</div>
  <div><strong>Do you want to continue?</strong></div>
  <p-footer>
    <button auto="dash-cancel-btn" class="btn btn-alt" type="button" pButton label="Cancel" (click)="confirmDialog.visible = false"></button>
    <button auto="dash-delete-btn" class="btn" type="button" pButton label="Delete" (click)="onConfirmDialogAccept()"></button>
  </p-footer>
</p-dialog>

<p-dialog #confirmDownloadSysAggReport
          styleClass="confirm-download-modal strategies-modal"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [visible]="confirmDownloadSysAggReportVisible"
          appendTo="body">
  <p-header class="strategies-modal-header">
    <i class="fa fa-download" aria-hidden="true"></i>
    <span class="dialog-title">Download Report</span>
  </p-header>
  <div>Thank you. We are processing your request. You will receive an email when your download is complete.</div>
  <div><strong>Please check your email and follow the link to access your requested report.</strong></div>
  <p-footer>
    <button auto="delete-btn" class="btn delete" type="button" pButton label="OK"
            (click)="confirmDownloadSysAggReportVisible = false"></button>
  </p-footer>
</p-dialog>

<p-dialog #copyPlanModal
          styleClass="copy-plan-modal"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          appendTo="body">
  <p-header class="strategies-modal-header">
    <img src="assets/images/copy-plan.svg" alt="Copy Plan">
    <span class="dialog-title">Copy Plan</span>
    <button class="copy-plan-modal-close-btn" (click)="this.copyPlanDialog.visible = false">
      <span class="eleot-icon icon-close"></span>
    </button>
  </p-header>
  <app-copy-plan-form
    #copyPlanForm
    (copySuccess)="onCopyPlanSuccess($event)"
    (strategyLoaded)="onCopyStrategyLoaded()"
    [strategy]="selectedStrategy"
    [institutionId]="institutionId"
  ></app-copy-plan-form>
</p-dialog>

